import { FC } from 'react';
import { Field } from 'react-final-form';
import FormError from '../Common/FormError';

const BorrowerDocumentsProve: FC = () => {
  return (
    <>
      <label className='form-label'>Please upload your supporting documents</label>
      <div className='mb-5 mt-5 col-lg-12'>
        <label className='form-label'>Proof of Income</label>
        <Field name='income_prove' type='file'>
          {({ input: { onChange, value, ...input }, meta }) => (
            <>
              <div className='mb-3'>
                <input type='file' {...input} onChange={({target}) => onChange(target.files)} className='form-control form-control-lg form-control-solid' />
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>
      <div className='mb-5 mt-5 col-lg-12'>
        <label className='form-label'>Proof of Business or Employment</label>
        <Field name='work_prove' type='file'>
          {({ input: { onChange, value, ...input }, meta }) => (
            <>
              <div className='mb-3'>
                <input type='file' {...input} onChange={({target}) => onChange(target.files)} className='form-control form-control-lg form-control-solid' />
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>
    </>
  );
};

export default BorrowerDocumentsProve;
